// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const ShareWidget = (el) => {
  const ui = {
    el,
    body: select('body', document),
    links: select.all('a', el),
  };

  const addShareURLs = () => {
    const currentURL = window.location.href;
    const pageTitle = document.title;

    const shareURLs = {
      facebook:   `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`,
      linkedin:   `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`,
      x:          `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}`,
      email:      `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentURL)}`,
    };

    ui.links.forEach((el) => {
      const target = el.dataset.target;

      if (target && shareURLs[target]) {
        el.href = shareURLs[target];
        el.target = '_blank'
      }
    });
  }

  const addEvents = () => {
    addShareURLs();
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default ShareWidget;
